<template>
  <vx-modal
    :title="
      !form.uuid ? $t('messages.create.title') : $t('messages.edit.title')
    "
    :active.sync="show"
    sizeModal="con-vs-popup-mid"
  >
    <form @submit.prevent="save" @keydown="form.onKeydown($event)">
      <div class="sm:w-12/12">
        <div class="vx-row mb-3">
          <div class="vx-col w-full">
            <vx-select
                :model.sync="routine"
                :disabled="routines.length == 0"
                :placeholder="PlaceholderRoutime"
                :options="routines"
                :translate="false"
                :uuid="true"
                class="w-full"
                label="Selecciona rutina"
            ></vx-select>
          </div>
        </div>
      </div>

      <div class="sm:w-12/12">
        <div class="vx-row mb-3">
          <div class="vx-col w-full">
            <vs-input
              :label="$t('routines_templates.labels.name')"
              name="name"
              class="w-full"
              v-model="form.name"
            />
            <has-error :form="form" field="name" />
          </div>
        </div>
      </div>

      <div class="sm:w-12/12">
        <div class="vx-row mb-3">
          <div class="vx-col w-full">
            <vx-select
              :model.sync="form.category_routine_id"
              :label="$t('routines_templates.labels.category_routine_id')"
              :options="categories"
              :translate="false"
              :uuid="false"
              :placeholder="$t('routines_templates.labels.category_routine_id')"
            ></vx-select>

            <has-error :form="form" field="category_routine_id" />
          </div>
        </div>
      </div>
      <div class="sm:w-12/12" v-if="form.category_routine_id == 1">
        <div class="vx-row mb-3">
          <div class="vx-col w-full">
            <vs-input
              :label="$t('routines_templates.labels.price')"
              name="price"
              class="w-full"
              v-model="form.price"
            />
            <has-error :form="form" field="price" />
          </div>
        </div>
      </div>

      <div class="sm:w-12/12">
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-textarea
              :label="$t('routines_templates.labels.description')"
              name="description"
              class="w-full"
              v-model="form.description"
              rows="3"
            />
            <has-error :form="form" field="description" />
          </div>
        </div>
      </div>

      <div class="sm:w-12/12">
        <div class="vx-row">
          <div class="vx-col w-full" v-if="weeks.length > 0">
            <vs-tabs alignment="fixed" v-model="week">
              <template v-for="(week, weekIndex) in weeks">
                <vs-tab :label="`Semana ${week.number}`" :key="weekIndex">
                  <vs-tabs alignment="fixed" v-model="day">
                    <template v-for="(day, dayIndex) in week.days">
                      <vs-tab
                        :label="`Día ${day.number}`"
                        :key="dayIndex"
                        style="overflow: visible"
                      >
                      <div class="sm:w-12/12">
                        <div class="vx-row mb-3">
                          <div class="vx-col w-full">
                            <vs-input
                              label="Tipo de trabajo"
                              name="type_work"
                              class="w-full"
                              v-model="day.type_work"
                            />
                            <div class="help-block invalid-feedback" v-if="form.errors && form.errors.has('weeks.' +
                                    weekIndex +
                                    '.days.' +
                                    dayIndex +
                                    '.type_work')">
                                    El campo tipo de trabajo es obligatorio.
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Calentamiento -->
                        <vs-card>
                          <vs-row
                            class="justify-content-between py-5 align-items-center"
                          >
                            <vs-col
                              vs-lg="4"
                              vs-sm="12"
                              vs-xs="12"
                              class="d-flex align-items-center"
                            >
                              <h2 class="pt-3">
                                Calentamiento
                              </h2>
                            </vs-col>
                            <vs-divider></vs-divider>
                          </vs-row>
                          <vs-row
                            vs-justify="center"
                            vs-w="12"
                            v-for="(compound, compoundIndex) in day.compounds"
                            :key="compoundIndex"
                            class="relative"
                          >
                            <vs-col v-if="compound.stage == 'Calentamiento'">
                              <h5
                                class="d-flex align-items-center justify-between mb-3"
                              >
                                <span>{{
                                  getNameCompound(compound.category_compound_id)
                                }}</span>
                              </h5>
                              <template v-if="compound.category_compound_id === 4">
                                <vs-row>
                                  <vs-col vs-lg="12" class="text-center">
                                      {{
                                        compound.workouts[0].name
                                          ? compound.workouts[0].name
                                          : alpha[compoundIndex]
                                      }}
                                  </vs-col>
                                  <vs-col
                                    vs-lg="11"
                                    vs-sm="10"
                                    vs-xs="10"
                                  >
                                    <vx-select
                                      :model.sync="compound.workouts[0].workout_id"
                                      :label="
                                        $t('routines_templates.labels.workout')
                                      "
                                      :options="workouts"
                                      :translate="false"
                                      :uuid="false"
                                      :placeholder="
                                        form.uuid ? compound.workouts[0].name : 'Ejercicio'
                                      "
                                      class="w-full"
                                    ></vx-select>
                                    <has-error
                                      :form="form"
                                      :field="
                                        'weeks.' +
                                          weekIndex +
                                          '.days.' +
                                          dayIndex +
                                          '.compounds.' +
                                          compoundIndex +
                                          '.workouts.' +
                                          0 +
                                          '.workout_id'
                                      "
                                    />
                                  </vs-col>
                                  <vs-col
                                    class="mt-4"
                                    :vs-lg="
                                      compound.category_compound_id == 7 ? 1 : 1
                                    "
                                    vs-sm="2"
                                    vs-xs="2"
                                  >
                                    <vs-icon
                                      size="medium"
                                      icon="delete"
                                      color="danger"
                                      style="cursor: pointer; float: right;"
                                      @click="deleteCompound(compoundIndex)"
                                    ></vs-icon>
                                  </vs-col>
                                  <vs-col
                                    v-if="
                                      compound.category_compound_id != 5 &&
                                        compound.category_compound_id != 7
                                    "
                                    vs-lg="2"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-3 mx-2"
                                  >
                                    <label for="" class="vs-input--label">{{
                                      $t('routines_templates.labels.series')
                                    }}</label>
                                    <div class="vx-row">
                                      <vs-input-number
                                        v-model="compound.workouts[0].series"
                                        max="99"
                                        min="0"
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col
                                  v-for="(workout,
                                  workoutIndex) in compound.workouts"
                                  :key="workoutIndex"
                                    vs-lg="3"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-3 mx-2 relative"
                                    
                                  >
                                    <div class="vx-row">
                                      <vs-input
                                        :label="`Repetición ${workoutIndex + 1}`"
                                        v-model="workout.repetitions"
                                        class="w-full"
                                      />
                                    <span class="add-reps" v-if="workoutIndex == 0 " @click="addPiramidal(compound, compound.workouts[0])">+ Agregar repeticiones</span>
                                    </div>
                                  </vs-col>
                                  <vs-col
                                    v-if="
                                      compound.category_compound_id != 5 &&
                                        compound.category_compound_id != 7
                                    "
                                    vs-lg="3"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-3 mx-2"
                                  >
                                    <div class="vx-row">
                                      <vs-input
                                        :label="
                                          $t('routines_templates.labels.rest')
                                        "
                                        class="w-full"
                                        v-model="compound.workouts[0].rest"
                                      />
                                    </div>
                                  </vs-col>

                                  <vs-col
                                    v-if="
                                      compound.category_compound_id != 5 &&
                                        compound.category_compound_id != 7
                                    "
                                    vs-lg="3"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-3 mx-2"
                                  >
                                    <div class="vx-row">
                                      <vs-input
                                        :label="
                                          $t('routines_templates.labels.tempo')
                                        "
                                        placeholder="(1-2-3)"
                                        name="tempo"
                                        class="w-full"
                                        v-model="compound.workouts[0].tempo"
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col
                                    vs-lg="6"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-1 py-3"
                                  >
                                    <vs-textarea
                                      :label="
                                        $t('routines_templates.labels.note')
                                      "
                                      name="note"
                                      rows="2"
                                      class="w-full"
                                      v-model="compound.workouts[0].note"
                                    />
                                  </vs-col>
                                  <vs-col
                                    vs-lg="6"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-1 py-3"
                                  >
                                    <vs-textarea
                                      :label="
                                        $t('routines_templates.labels.overload')
                                      "
                                      name="note"
                                      rows="2"
                                      class="w-full"
                                      v-model="compound.workouts[0].overload"
                                    />
                                  </vs-col>
                                </vs-row>
                              </template>
                              <template v-if="compound.category_compound_id === 5">
                                <vs-row
                                  vs-justify="center"
                                  vs-w="12"
                                  class="relative"
                                >
                                 <vs-col
                                    class="mt-4"
                                    vs-w="12"
                                    vs-xs="2"
                                  >
                                    <vs-icon
                                      size="medium"
                                      icon="delete"
                                      color="danger"
                                      style="cursor: pointer; float: right;"
                                      @click="deleteCompound(compoundIndex)"
                                    ></vs-icon>
                                  </vs-col>
                                  <vs-col
                                    vs-lg="3"
                                    vs-md="6"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-2"
                                  >
                                    <label for="" class="vs-input--label">{{
                                      $t('routines_templates.labels.preparing_time')
                                    }}</label>
                                    <div class="vx-row">
                                      <vs-input-number
                                        class="w-full"
                                        :label="
                                        $t('routines_templates.labels.timer')
                                      "
                                        v-model="compound.workouts[0].preparing_time"
                                        max="99"
                                        min="0"
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col
                                    vs-lg="3"
                                    vs-md="6"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-2"
                                  >
                                    <label for="" class="vs-input--label">{{
                                      $t('routines_templates.labels.cycles')
                                    }}</label>
                                    <div class="vx-row">
                                      <div class="vs-input-number w-full vs-input-number-size-null vs-input-number-primary">
                                        <button @click="removeHiit(compound)" type="button" class="btn-less vs-input-number--button-less">
                                          <i class="vs-icon notranslate icon-scale material-icons null">remove</i>
                                        </button>
                                        <input :value="compound.workouts.length" :disabled="true" type="number" min="1" max="99" class="vs-input-number--input" style="width: 9.1px; background-color: inherit!important;">
                                        <button @click="addHiit(compound, compound.workouts[0])" type="button" class="btn-plus vs-input-number--button-plus">
                                          <i class="vs-icon notranslate icon-scale material-icons null">add</i>
                                        </button>
                                      </div>
                                    </div>
                                  </vs-col>
                                  <vs-col
                                    vs-lg="3"
                                    vs-md="6"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-2"
                                  >
                                    <label for="" class="vs-input--label">{{
                                      $t('routines_templates.labels.series')
                                    }}</label>
                                    <div class="vx-row">
                                      <vs-input-number
                                        class="w-full"
                                        v-model="compound.workouts[0].series"
                                        max="99"
                                        min="0"
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col
                                    vs-lg="3"
                                    vs-md="6"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-2"
                                  >
                                    <label for="" class="vs-input--label">{{
                                      $t('routines_templates.labels.rest')
                                    }}</label>
                                    <div class="vx-row">
                                      <vs-input-number
                                        class="w-full"
                                        :label="
                                        $t('routines_templates.labels.timer')
                                      "
                                        v-model="compound.workouts[0].rest"
                                        max="99"
                                        min="0"
                                        name="rest"
                                      />
                                    </div>
                                  </vs-col>
                                  <template v-for="(workout,
                                    workoutIndex) in compound.workouts">
                                    <div :key="workoutIndex" class="vs-row vs-lg-12">
                                      <vs-col
                                        vs-lg="6"
                                        vs-sm="12"
                                        vs-xs="12"
                                        class="p-2"
                                      >
                                        <vx-select
                                            :model.sync="workout.workout_id"
                                            :label="
                                              $t('routines_templates.labels.workout')
                                            "
                                            :options="workouts"
                                            :translate="false"
                                            :uuid="false"
                                            :placeholder="
                                              form.uuid ? workout.name : 'Ejercicio'
                                            "
                                            class="w-full"
                                          ></vx-select>
                                          <has-error
                                            :form="form"
                                            :field="
                                              'weeks.' +
                                                weekIndex +
                                                '.days.' +
                                                dayIndex +
                                                '.compounds.' +
                                                compoundIndex +
                                                '.workouts.' +
                                                workoutIndex +
                                                '.workout_id'
                                            "
                                          />
                                      </vs-col>
                                      <vs-col
                                        vs-lg="6"
                                        vs-sm="12"
                                        vs-xs="12"
                                        class="p-2"
                                      >
                                        <label for="">{{ $t('routines_templates.labels.chronometer') }}</label>
                                        <vs-input-number
                                          :label="
                                            $t('routines_templates.labels.timer')
                                          "
                                          name="timer"
                                          max="99"
                                          min="0"
                                          v-model="workout.timer"
                                        />
                                      </vs-col>
                                    </div>
                                  </template>
                                  <vs-divider></vs-divider>
                                </vs-row>
                              </template>
                              <template v-else-if="compound.category_compound_id !== 4 && compound.category_compound_id !== 5">
                                <vs-row
                                  vs-justify="center"
                                  vs-w="12"
                                  v-for="(workout,
                                  workoutIndex) in compound.workouts"
                                  :key="workoutIndex"
                                  class="relative"
                                >
                                  
                                  <vs-col vs-lg="12" class="text-center">
                                    {{
                                      workout.name
                                        ? workout.name
                                        : alpha[compoundIndex] +
                                          (workoutIndex + 1) + compound.category_compound_id
                                    }}
                                  </vs-col>
                                  <vs-col
                                    v-if="compound.category_compound_id != 7"
                                    vs-lg="11"
                                    vs-sm="10"
                                    vs-xs="10"
                                  >
                                    <vx-select
                                      :model.sync="workout.workout_id"
                                      :label="
                                        $t('routines_templates.labels.workout')
                                      "
                                      :options="workouts"
                                      :translate="false"
                                      :uuid="false"
                                      :placeholder="
                                        form.uuid ? workout.name : 'Ejercicio'
                                      "
                                      class="w-full"
                                    ></vx-select>
                                    <has-error
                                      :form="form"
                                      :field="
                                        'weeks.' +
                                          weekIndex +
                                          '.days.' +
                                          dayIndex +
                                          '.compounds.' +
                                          compoundIndex +
                                          '.workouts.' +
                                          workoutIndex +
                                          '.workout_id'
                                      "
                                    />
                                  </vs-col>
                                  <vs-col
                                    class="mt-4"
                                    :vs-lg="
                                      compound.category_compound_id == 7 ? 1 : 1
                                    "
                                    vs-sm="2"
                                    vs-xs="2"
                                  >
                                    <vs-icon
                                      size="medium"
                                      icon="delete"
                                      color="danger"
                                      style="cursor: pointer; float: right;"
                                      @click="deleteCompound(compoundIndex)"
                                    ></vs-icon>
                                  </vs-col>
                                  <vs-col
                                    v-if="
                                      compound.category_compound_id != 5 &&
                                        compound.category_compound_id != 7
                                    "
                                    vs-lg="2"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-3 mx-2"
                                  >
                                    <label for="" class="vs-input--label">{{
                                      $t('routines_templates.labels.series')
                                    }}</label>
                                    <div class="vx-row">
                                      <vs-input-number
                                        v-model="workout.series"
                                        max="99"
                                        min="0"
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col
                                    v-if="
                                      compound.category_compound_id != 5 &&
                                        compound.category_compound_id != 7
                                    "
                                    vs-lg="3"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-3 mx-2"
                                  >
                                    <div class="vx-row">
                                      <vs-input
                                        :label="
                                          $t('routines_templates.labels.reps')
                                        "
                                        v-model="workout.repetitions"
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col
                                    v-if="
                                      compound.category_compound_id != 5 &&
                                        compound.category_compound_id != 7
                                    "
                                    vs-lg="3"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-3 mx-2"
                                  >
                                    <div class="vx-row">
                                      <vs-input
                                        :label="
                                          $t('routines_templates.labels.rest')
                                        "
                                        v-model="workout.rest"
                                      />
                                    </div>
                                  </vs-col>


                                  <vs-col
                                    v-if="
                                      compound.category_compound_id != 5 &&
                                        compound.category_compound_id != 7
                                    "
                                    vs-lg="3"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-3 mx-2"
                                  >
                                    <div class="vx-row">
                                      <vs-input
                                        :label="
                                          $t('routines_templates.labels.tempo')
                                        "
                                        placeholder="(1-2-3)"
                                        name="tempo"
                                        class="w-full"
                                        v-model="workout.tempo"
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col
                                    vs-lg="6"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-1 py-3"
                                  >
                                    <vs-textarea
                                      :label="
                                        $t('routines_templates.labels.note')
                                      "
                                      name="note"
                                      rows="2"
                                      class="w-full"
                                      v-model="workout.note"
                                    />
                                  </vs-col>
                                  <vs-col
                                    vs-lg="6"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-1 py-3"
                                  >
                                    <vs-textarea
                                      :label="
                                        $t('routines_templates.labels.overload')
                                      "
                                      name="note"
                                      rows="2"
                                      class="w-full"
                                      v-model="workout.overload"
                                      v-if="
                                        compound.category_compound_id != 5 &&
                                          compound.category_compound_id != 7
                                      "
                                    />
                                  </vs-col>
                                  <vs-divider></vs-divider>
                                </vs-row>
                              </template>
                            </vs-col>
                          </vs-row>
                          <vs-row class="justify-end">
                            <vs-col vs-lg="8" vs-sm="12" vs-xs="12">
                              <vx-select
                                :model.sync="compound.category_compound_id"
                                label="Tipo de ejercicio"
                                :options="categoriesCompounds"
                                :translate="false"
                                :uuid="false"
                                :placeholder="'Ejecicio'"
                                class="w-full abs"
                              ></vx-select>
                            </vs-col>
                            <vs-col
                              vs-lg="4"
                              vs-sm="12"
                              vs-xs="12"
                              class="pt-4 text-center"
                            >
                              <vs-button
                                class="md:mb-0"
                                v-on:click="
                                  addCompound(
                                    compound.category_compound_id,
                                    'Calentamiento'
                                  )
                                "
                                button="button"
                              >
                                {{ $t('routines_templates.labels.add') }}
                              </vs-button>
                            </vs-col>
                          </vs-row>
                        </vs-card>
                        <vs-card>
                          <vs-row
                            class="justify-content-between py-5 align-items-center"
                          >
                            <vs-col
                              vs-lg="4"
                              vs-sm="12"
                              vs-xs="12"
                              class="d-flex align-items-center"
                            >
                              <h2 class="pt-3">
                                Rutina
                              </h2>
                            </vs-col>
                            <vs-divider></vs-divider>
                          </vs-row>
                          <vs-row
                            vs-justify="center"
                            vs-w="12"
                            v-for="(compound, compoundIndex) in day.compounds"
                            :key="compoundIndex"
                            class="relative"
                          >
                            <vs-col v-if="compound.stage == 'Rutina'">
                              <h5
                                class="d-flex align-items-center justify-between mb-3"
                              >
                                <span>{{
                                  getNameCompound(compound.category_compound_id)
                                }}</span>
                              </h5>
                              <template v-if="compound.category_compound_id === 4">
                                <vs-row>
                                <vs-col vs-lg="12" class="text-center">
                                    {{
                                      compound.workouts[0].name
                                        ? compound.workouts[0].name
                                        : alpha[compoundIndex]
                                    }}
                                  </vs-col>
                                  <vs-col
                                    vs-lg="11"
                                    vs-sm="10"
                                    vs-xs="10"
                                  >
                                    <vx-select
                                      :model.sync="compound.workouts[0].workout_id"
                                      :label="
                                        $t('routines_templates.labels.workout')
                                      "
                                      :options="workouts"
                                      :translate="false"
                                      :uuid="false"
                                      :placeholder="
                                        form.uuid ? compound.workouts[0].name : 'Ejercicio'
                                      "
                                      class="w-full"
                                    ></vx-select>
                                    <has-error
                                      :form="form"
                                      :field="
                                        'weeks.' +
                                          weekIndex +
                                          '.days.' +
                                          dayIndex +
                                          '.compounds.' +
                                          compoundIndex +
                                          '.workouts.' +
                                          0 +
                                          '.workout_id'
                                      "
                                    />
                                  </vs-col>
                                  <vs-col
                                    class="mt-4"
                                    :vs-lg="
                                      compound.category_compound_id == 7 ? 1 : 1
                                    "
                                    vs-sm="2"
                                    vs-xs="2"
                                  >
                                    <vs-icon
                                      size="medium"
                                      icon="delete"
                                      color="danger"
                                      style="cursor: pointer; float: right;"
                                      @click="deleteCompound(compoundIndex)"
                                    ></vs-icon>
                                  </vs-col>
                                  <vs-col
                                    v-if="
                                      compound.category_compound_id != 5 &&
                                        compound.category_compound_id != 7
                                    "
                                    vs-lg="2"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-3 mx-2"
                                  >
                                    <label for="" class="vs-input--label">{{
                                      $t('routines_templates.labels.series')
                                    }}</label>
                                    <div class="vx-row">
                                      <vs-input-number
                                        v-model="compound.workouts[0].series"
                                        max="99"
                                        min="0"
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col
                                  v-for="(workout,
                                  workoutIndex) in compound.workouts"
                                  :key="workoutIndex"
                                    vs-lg="3"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-3 mx-2 relative"
                                    
                                  >
                                    <div class="vx-row">
                                      <vs-input
                                        :label="`Repetición ${workoutIndex + 1}` "
                                        v-model="workout.repetitions"
                                        class="w-full"
                                      />
                                    <span class="add-reps" v-if="workoutIndex == 0 " @click="addPiramidal(compound, compound.workouts[0])">+ Agregar repeticiones</span>
                                    </div>
                                  </vs-col>
                                  <vs-col
                                    v-if="
                                      compound.category_compound_id != 5 &&
                                        compound.category_compound_id != 7
                                    "
                                    vs-lg="3"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-3 mx-2"
                                  >
                                    <div class="vx-row">
                                      <vs-input
                                        :label="
                                          $t('routines_templates.labels.rest')
                                        "
                                        class="w-full"
                                        v-model="compound.workouts[0].rest"
                                      />
                                    </div>
                                  </vs-col>

                                  <vs-col
                                    v-if="
                                      compound.category_compound_id != 5 &&
                                        compound.category_compound_id != 7
                                    "
                                    vs-lg="3"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-3 mx-2"
                                  >
                                    <div class="vx-row">
                                      <vs-input
                                        :label="
                                          $t('routines_templates.labels.tempo')
                                        "
                                        placeholder="(1-2-3)"
                                        name="tempo"
                                        class="w-full"
                                        v-model="compound.workouts[0].tempo"
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col
                                    vs-lg="6"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-1 py-3"
                                  >
                                    <vs-textarea
                                      :label="
                                        $t('routines_templates.labels.note')
                                      "
                                      name="note"
                                      rows="2"
                                      class="w-full"
                                      v-model="compound.workouts[0].note"
                                    />
                                  </vs-col>
                                  <vs-col
                                    vs-lg="6"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-1 py-3"
                                  >
                                    <vs-textarea
                                      :label="
                                        $t('routines_templates.labels.overload')
                                      "
                                      name="note"
                                      rows="2"
                                      class="w-full"
                                      v-model="compound.workouts[0].overload"
                                    />
                                  </vs-col>
                                  </vs-row>
                              </template>
                              <template v-if="compound.category_compound_id === 5">
                                <vs-row
                                  vs-justify="center"
                                  vs-w="12"
                                  class="relative"
                                >
                                 <vs-col
                                    class="mt-4"
                                    vs-w="12"
                                    vs-xs="2"
                                  >
                                    <vs-icon
                                      size="medium"
                                      icon="delete"
                                      color="danger"
                                      style="cursor: pointer; float: right;"
                                      @click="deleteCompound(compoundIndex)"
                                    ></vs-icon>
                                  </vs-col>
                                  <vs-col
                                    vs-lg="3"
                                    vs-md="6"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-2"
                                  >
                                    <label for="" class="vs-input--label">{{
                                      $t('routines_templates.labels.preparing_time')
                                    }}</label>
                                    <div class="vx-row">
                                      <vs-input-number
                                        class="w-full"
                                        :label="
                                        $t('routines_templates.labels.timer')
                                      "
                                        v-model="compound.workouts[0].preparing_time"
                                        max="99"
                                        min="0"
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col
                                    vs-lg="3"
                                    vs-md="6"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-2"
                                  >
                                    <label for="" class="vs-input--label">{{
                                      $t('routines_templates.labels.cycles')
                                    }}</label>
                                    <div class="vx-row">
                                      <div class="vs-input-number w-full vs-input-number-size-null vs-input-number-primary">
                                        <button @click="removeHiit(compound)" type="button" class="btn-less vs-input-number--button-less">
                                          <i class="vs-icon notranslate icon-scale material-icons null">remove</i>
                                        </button>
                                        <input :value="compound.workouts.length" :disabled="true" type="number" min="1" max="99" class="vs-input-number--input" style="width: 9.1px; background-color: inherit!important;">
                                        <button @click="addHiit(compound, compound.workouts[0])" type="button" class="btn-plus vs-input-number--button-plus">
                                          <i class="vs-icon notranslate icon-scale material-icons null">add</i>
                                        </button>
                                      </div>
                                    </div>
                                  </vs-col>
                                  <vs-col
                                    vs-lg="3"
                                    vs-md="6"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-2"
                                  >
                                    <label for="" class="vs-input--label">{{
                                      $t('routines_templates.labels.series')
                                    }}</label>
                                    <div class="vx-row">
                                      <vs-input-number
                                        class="w-full"
                                        v-model="compound.workouts[0].series"
                                        max="99"
                                        min="0"
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col
                                    vs-lg="3"
                                    vs-md="6"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-2"
                                  >
                                    <label for="" class="vs-input--label">{{
                                      $t('routines_templates.labels.rest')
                                    }}</label>
                                    <div class="vx-row">
                                      <vs-input-number
                                        class="w-full"
                                        :label="
                                        $t('routines_templates.labels.timer')
                                      "
                                        v-model="compound.workouts[0].rest"
                                        max="99"
                                        min="0"
                                        name="rest"
                                      />
                                    </div>
                                  </vs-col>
                                  <template v-for="(workout,
                                    workoutIndex) in compound.workouts">
                                    <div :key="workoutIndex" class="vs-row vs-lg-12">
                                      <vs-col
                                        vs-lg="6"
                                        vs-sm="12"
                                        vs-xs="12"
                                        class="p-2"
                                      >
                                        <vx-select
                                            :model.sync="workout.workout_id"
                                            :label="
                                              $t('routines_templates.labels.workout')
                                            "
                                            :options="workouts"
                                            :translate="false"
                                            :uuid="false"
                                            :placeholder="
                                              form.uuid ? workout.name : 'Ejercicio'
                                            "
                                            class="w-full"
                                          ></vx-select>
                                          <has-error
                                            :form="form"
                                            :field="
                                              'weeks.' +
                                                weekIndex +
                                                '.days.' +
                                                dayIndex +
                                                '.compounds.' +
                                                compoundIndex +
                                                '.workouts.' +
                                                workoutIndex +
                                                '.workout_id'
                                            "
                                          />
                                      </vs-col>
                                      <vs-col
                                        vs-lg="6"
                                        vs-sm="12"
                                        vs-xs="12"
                                        class="p-2"
                                      >
                                        <label for="">{{ $t('routines_templates.labels.chronometer') }}</label>
                                        <vs-input-number
                                          :label="
                                            $t('routines_templates.labels.timer')
                                          "
                                          name="timer"
                                          max="99"
                                          min="0"
                                          v-model="workout.timer"
                                        />
                                      </vs-col>
                                    </div>
                                  </template>
                                  <vs-divider></vs-divider>
                                </vs-row>
                              </template>
                              <template v-else-if="compound.category_compound_id !== 4 && compound.category_compound_id !== 5">
                                <vs-row
                                  vs-justify="center"
                                  vs-w="12"
                                  v-for="(workout,
                                  workoutIndex) in compound.workouts"
                                  :key="workoutIndex"
                                  class="relative"
                                >
                                  
                                  <vs-col vs-lg="12" class="text-center">
                                    {{
                                      workout.name
                                        ? workout.name
                                        : alpha[compoundIndex] +
                                          (workoutIndex + 1)
                                    }}
                                  </vs-col>
                                  <vs-col
                                    v-if="compound.category_compound_id != 7"
                                    vs-lg="11"
                                    vs-sm="10"
                                    vs-xs="10"
                                  >
                                    <vx-select
                                      :model.sync="workout.workout_id"
                                      :label="
                                        $t('routines_templates.labels.workout')
                                      "
                                      :options="workouts"
                                      :translate="false"
                                      :uuid="false"
                                      :placeholder="
                                        form.uuid ? workout.name : 'Ejercicio'
                                      "
                                      class="w-full"
                                    ></vx-select>
                                    <has-error
                                      :form="form"
                                      :field="
                                        'weeks.' +
                                          weekIndex +
                                          '.days.' +
                                          dayIndex +
                                          '.compounds.' +
                                          compoundIndex +
                                          '.workouts.' +
                                          workoutIndex +
                                          '.workout_id'
                                      "
                                    />
                                  </vs-col>
                                  <vs-col
                                    class="mt-4"
                                    :vs-lg="
                                      compound.category_compound_id == 7 ? 1 : 1
                                    "
                                    vs-sm="2"
                                    vs-xs="2"
                                  >
                                    <vs-icon
                                      size="medium"
                                      icon="delete"
                                      color="danger"
                                      style="cursor: pointer; float: right;"
                                      @click="deleteCompound(compoundIndex)"
                                    ></vs-icon>
                                  </vs-col>
                                  <vs-col
                                    v-if="
                                      compound.category_compound_id != 5 &&
                                        compound.category_compound_id != 7
                                    "
                                    vs-lg="2"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-3 mx-2"
                                  >
                                    <label for="" class="vs-input--label">{{
                                      $t('routines_templates.labels.series')
                                    }}</label>
                                    <div class="vx-row">
                                      <vs-input-number
                                        v-model="workout.series"
                                        max="99"
                                        min="0"
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col
                                    v-if="
                                      compound.category_compound_id != 5 &&
                                        compound.category_compound_id != 7
                                    "
                                    vs-lg="3"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-3 mx-2"
                                  >
                                    <div class="vx-row">
                                      <vs-input
                                        :label="
                                          $t('routines_templates.labels.reps')
                                        "
                                        v-model="workout.repetitions"
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col
                                    v-if="
                                      compound.category_compound_id != 5 &&
                                        compound.category_compound_id != 7
                                    "
                                    vs-lg="3"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-3 mx-2"
                                  >
                                    <div class="vx-row">
                                      <vs-input
                                        :label="
                                          $t('routines_templates.labels.rest')
                                        "
                                        v-model="workout.rest"
                                      />
                                    </div>
                                  </vs-col>


                                  <vs-col
                                    v-if="
                                      compound.category_compound_id != 5 &&
                                        compound.category_compound_id != 7
                                    "
                                    vs-lg="3"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-3 mx-2"
                                  >
                                    <div class="vx-row">
                                      <vs-input
                                        :label="
                                          $t('routines_templates.labels.tempo')
                                        "
                                        placeholder="(1-2-3)"
                                        name="tempo"
                                        class="w-full"
                                        v-model="workout.tempo"
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col
                                    vs-lg="6"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-1 py-3"
                                  >
                                    <vs-textarea
                                      :label="
                                        $t('routines_templates.labels.note')
                                      "
                                      name="note"
                                      rows="2"
                                      class="w-full"
                                      v-model="workout.note"
                                    />
                                  </vs-col>
                                  <vs-col
                                    vs-lg="6"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-1 py-3"
                                  >
                                    <vs-textarea
                                      :label="
                                        $t('routines_templates.labels.overload')
                                      "
                                      name="note"
                                      rows="2"
                                      class="w-full"
                                      v-model="workout.overload"
                                      v-if="
                                        compound.category_compound_id != 5 &&
                                          compound.category_compound_id != 7
                                      "
                                    />
                                  </vs-col>
                                  <vs-divider></vs-divider>
                                </vs-row>
                              </template>
                            </vs-col>
                          </vs-row>
                          <vs-row class="justify-end">
                            <vs-col vs-lg="8" vs-sm="12" vs-xs="12">
                              <vx-select
                                :model.sync="compound.category_compound_id"
                                label="Tipo de ejercicio"
                                :options="categoriesCompounds"
                                :translate="false"
                                :uuid="false"
                                :placeholder="'Ejecicio'"
                                class="w-full abs"
                              ></vx-select>
                            </vs-col>
                            <vs-col
                              vs-lg="4"
                              vs-sm="12"
                              vs-xs="12"
                              class="pt-4 text-center"
                            >
                              <vs-button
                                class="md:mb-0"
                                v-on:click="
                                  addCompound(
                                    compound.category_compound_id,
                                    'Rutina'
                                  )
                                "
                                button="button"
                              >
                                {{ $t('routines_templates.labels.add') }}
                              </vs-button>
                            </vs-col>
                          </vs-row>
                        </vs-card>
                        <vs-card>
                          <vs-row
                            class="justify-content-between py-5 align-items-center"
                          >
                            <vs-col
                              vs-lg="4"
                              vs-sm="12"
                              vs-xs="12"
                              class="d-flex align-items-center"
                            >
                              <h2 class="pt-3">
                                Estiramiento
                              </h2>
                            </vs-col>
                            <vs-divider></vs-divider>
                          </vs-row>
                          <vs-row
                            vs-justify="center"
                            vs-w="12"
                            v-for="(compound, compoundIndex) in day.compounds"
                            :key="compoundIndex"
                            class="relative"
                          >
                            <vs-col v-if="compound.stage == 'Estiramiento'">
                              <h5
                                class="d-flex align-items-center justify-between mb-3"
                              >
                                <span>{{
                                  getNameCompound(compound.category_compound_id)
                                }}</span>
                              </h5>
                              <template v-if="compound.category_compound_id === 4">
                                <vs-row>
                                <vs-col vs-lg="12" class="text-center">
                                    {{
                                      compound.workouts[0].name
                                        ? compound.workouts[0].name
                                        : alpha[compoundIndex]
                                    }}
                                  </vs-col>
                                  <vs-col
                                    vs-lg="11"
                                    vs-sm="10"
                                    vs-xs="10"
                                  >
                                    <vx-select
                                      :model.sync="compound.workouts[0].workout_id"
                                      :label="
                                        $t('routines_templates.labels.workout')
                                      "
                                      :options="workouts"
                                      :translate="false"
                                      :uuid="false"
                                      :placeholder="
                                        form.uuid ? compound.workouts[0].name : 'Ejercicio'
                                      "
                                      class="w-full"
                                    ></vx-select>
                                    <has-error
                                      :form="form"
                                      :field="
                                        'weeks.' +
                                          weekIndex +
                                          '.days.' +
                                          dayIndex +
                                          '.compounds.' +
                                          compoundIndex +
                                          '.workouts.' +
                                          0 +
                                          '.workout_id'
                                      "
                                    />
                                  </vs-col>
                                  <vs-col
                                    class="mt-4"
                                    :vs-lg="
                                      compound.category_compound_id == 7 ? 1 : 1
                                    "
                                    vs-sm="2"
                                    vs-xs="2"
                                  >
                                    <vs-icon
                                      size="medium"
                                      icon="delete"
                                      color="danger"
                                      style="cursor: pointer; float: right;"
                                      @click="deleteCompound(compoundIndex)"
                                    ></vs-icon>
                                  </vs-col>
                                  <vs-col
                                    v-if="
                                      compound.category_compound_id != 5 &&
                                        compound.category_compound_id != 7
                                    "
                                    vs-lg="2"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-3 mx-2"
                                  >
                                    <label for="" class="vs-input--label">{{
                                      $t('routines_templates.labels.series')
                                    }}</label>
                                    <div class="vx-row">
                                      <vs-input-number
                                        v-model="compound.workouts[0].series"
                                        max="99"
                                        min="0"
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col
                                  v-for="(workout,
                                  workoutIndex) in compound.workouts"
                                  :key="workoutIndex"
                                    vs-lg="3"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-3 mx-2 relative"
                                    
                                  >
                                    <div class="vx-row">
                                      <vs-input
                                        :label="`Repetición ${workoutIndex + 1}`"
                                        v-model="workout.repetitions"
                                        class="w-full"
                                      />
                                    <span class="add-reps" v-if="workoutIndex == 0 " @click="addPiramidal(compound, compound.workouts[0])">+ Agregar repeticiones</span>
                                    </div>
                                  </vs-col>
                                  <vs-col
                                    v-if="
                                      compound.category_compound_id != 5 &&
                                        compound.category_compound_id != 7
                                    "
                                    vs-lg="3"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-3 mx-2"
                                  >
                                    <div class="vx-row">
                                      <vs-input
                                        :label="
                                          $t('routines_templates.labels.rest')
                                        "
                                        class="w-full"
                                        v-model="compound.workouts[0].rest"
                                      />
                                    </div>
                                  </vs-col>

                                  <vs-col
                                    v-if="
                                      compound.category_compound_id != 5 &&
                                        compound.category_compound_id != 7
                                    "
                                    vs-lg="3"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-3 mx-2"
                                  >
                                    <div class="vx-row">
                                      <vs-input
                                        :label="
                                          $t('routines_templates.labels.tempo')
                                        "
                                        placeholder="(1-2-3)"
                                        name="tempo"
                                        class="w-full"
                                        v-model="compound.workouts[0].tempo"
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col
                                    vs-lg="6"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-1 py-3"
                                  >
                                    <vs-textarea
                                      :label="
                                        $t('routines_templates.labels.note')
                                      "
                                      name="note"
                                      rows="2"
                                      class="w-full"
                                      v-model="compound.workouts[0].note"
                                    />
                                  </vs-col>
                                  <vs-col
                                    vs-lg="6"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-1 py-3"
                                  >
                                    <vs-textarea
                                      :label="
                                        $t('routines_templates.labels.overload')
                                      "
                                      name="note"
                                      rows="2"
                                      class="w-full"
                                      v-model="compound.workouts[0].overload"
                                    />
                                  </vs-col>
                                  </vs-row>
                              </template>
                              <template v-if="compound.category_compound_id === 5">
                                <vs-row
                                  vs-justify="center"
                                  vs-w="12"
                                  class="relative"
                                >
                                 <vs-col
                                    class="mt-4"
                                    vs-w="12"
                                    vs-xs="2"
                                  >
                                    <vs-icon
                                      size="medium"
                                      icon="delete"
                                      color="danger"
                                      style="cursor: pointer; float: right;"
                                      @click="deleteCompound(compoundIndex)"
                                    ></vs-icon>
                                  </vs-col>
                                  <vs-col
                                    vs-lg="3"
                                    vs-md="6"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-2"
                                  >
                                    <label for="" class="vs-input--label">{{
                                      $t('routines_templates.labels.preparing_time')
                                    }}</label>
                                    <div class="vx-row">
                                      <vs-input-number
                                        class="w-full"
                                        :label="
                                        $t('routines_templates.labels.timer')
                                      "
                                        v-model="compound.workouts[0].preparing_time"
                                        max="99"
                                        min="0"
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col
                                    vs-lg="3"
                                    vs-md="6"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-2"
                                  >
                                    <label for="" class="vs-input--label">{{
                                      $t('routines_templates.labels.cycles')
                                    }}</label>
                                    <div class="vx-row">
                                      <div class="vs-input-number w-full vs-input-number-size-null vs-input-number-primary">
                                        <button @click="removeHiit(compound)" type="button" class="btn-less vs-input-number--button-less">
                                          <i class="vs-icon notranslate icon-scale material-icons null">remove</i>
                                        </button>
                                        <input :value="compound.workouts.length" :disabled="true" type="number" min="1" max="99" class="vs-input-number--input" style="width: 9.1px; background-color: inherit!important;">
                                        <button @click="addHiit(compound, compound.workouts[0])" type="button" class="btn-plus vs-input-number--button-plus">
                                          <i class="vs-icon notranslate icon-scale material-icons null">add</i>
                                        </button>
                                      </div>
                                    </div>
                                  </vs-col>
                                  <vs-col
                                    vs-lg="3"
                                    vs-md="6"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-2"
                                  >
                                    <label for="" class="vs-input--label">{{
                                      $t('routines_templates.labels.series')
                                    }}</label>
                                    <div class="vx-row">
                                      <vs-input-number
                                        class="w-full"
                                        v-model="compound.workouts[0].series"
                                        max="99"
                                        min="0"
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col
                                    vs-lg="3"
                                    vs-md="6"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-2"
                                  >
                                    <label for="" class="vs-input--label">{{
                                      $t('routines_templates.labels.rest')
                                    }}</label>
                                    <div class="vx-row">
                                      <vs-input-number
                                        class="w-full"
                                        :label="
                                        $t('routines_templates.labels.timer')
                                      "
                                        v-model="compound.workouts[0].rest"
                                        max="99"
                                        min="0"
                                        name="rest"
                                      />
                                    </div>
                                  </vs-col>
                                  <template v-for="(workout,
                                    workoutIndex) in compound.workouts">
                                    <div :key="workoutIndex" class="vs-row vs-lg-12">
                                      <vs-col
                                        vs-lg="6"
                                        vs-sm="12"
                                        vs-xs="12"
                                        class="p-2"
                                      >
                                        <vx-select
                                            :model.sync="workout.workout_id"
                                            :label="
                                              $t('routines_templates.labels.workout')
                                            "
                                            :options="workouts"
                                            :translate="false"
                                            :uuid="false"
                                            :placeholder="
                                              form.uuid ? workout.name : 'Ejercicio'
                                            "
                                            class="w-full"
                                          ></vx-select>
                                          <has-error
                                            :form="form"
                                            :field="
                                              'weeks.' +
                                                weekIndex +
                                                '.days.' +
                                                dayIndex +
                                                '.compounds.' +
                                                compoundIndex +
                                                '.workouts.' +
                                                workoutIndex +
                                                '.workout_id'
                                            "
                                          />
                                      </vs-col>
                                      <vs-col
                                        vs-lg="6"
                                        vs-sm="12"
                                        vs-xs="12"
                                        class="p-2"
                                      >
                                        <label for="">{{ $t('routines_templates.labels.chronometer') }}</label>
                                        <vs-input-number
                                          :label="
                                            $t('routines_templates.labels.timer')
                                          "
                                          name="timer"
                                          max="99"
                                          min="0"
                                          v-model="workout.timer"
                                        />
                                      </vs-col>
                                    </div>
                                  </template>
                                  <vs-divider></vs-divider>
                                </vs-row>
                              </template>
                              <template v-else-if="compound.category_compound_id !== 4 && compound.category_compound_id !== 5">
                                <vs-row
                                  vs-justify="center"
                                  vs-w="12"
                                  v-for="(workout,
                                  workoutIndex) in compound.workouts"
                                  :key="workoutIndex"
                                  class="relative"
                                >
                                  
                                  <vs-col vs-lg="12" class="text-center">
                                    {{
                                      workout.name
                                        ? workout.name
                                        : alpha[compoundIndex] +
                                          (workoutIndex + 1)
                                    }}
                                  </vs-col>
                                  <vs-col
                                    v-if="compound.category_compound_id != 7"
                                    vs-lg="11"
                                    vs-sm="10"
                                    vs-xs="10"
                                  >
                                    <vx-select
                                      :model.sync="workout.workout_id"
                                      :label="
                                        $t('routines_templates.labels.workout')
                                      "
                                      :options="workouts"
                                      :translate="false"
                                      :uuid="false"
                                      :placeholder="
                                        form.uuid ? workout.name : 'Ejercicio'
                                      "
                                      class="w-full"
                                    ></vx-select>
                                    <has-error
                                      :form="form"
                                      :field="
                                        'weeks.' +
                                          weekIndex +
                                          '.days.' +
                                          dayIndex +
                                          '.compounds.' +
                                          compoundIndex +
                                          '.workouts.' +
                                          workoutIndex +
                                          '.workout_id'
                                      "
                                    />
                                  </vs-col>
                                  <vs-col
                                    class="mt-4"
                                    :vs-lg="
                                      compound.category_compound_id == 7 ? 1 : 1
                                    "
                                    vs-sm="2"
                                    vs-xs="2"
                                  >
                                    <vs-icon
                                      size="medium"
                                      icon="delete"
                                      color="danger"
                                      style="cursor: pointer; float: right;"
                                      @click="deleteCompound(compoundIndex)"
                                    ></vs-icon>
                                  </vs-col>
                                  <vs-col
                                    v-if="
                                      compound.category_compound_id != 5 &&
                                        compound.category_compound_id != 7
                                    "
                                    vs-lg="2"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-3 mx-2"
                                  >
                                    <label for="" class="vs-input--label">{{
                                      $t('routines_templates.labels.series')
                                    }}</label>
                                    <div class="vx-row">
                                      <vs-input-number
                                        v-model="workout.series"
                                        max="99"
                                        min="0"
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col
                                    v-if="
                                      compound.category_compound_id != 5 &&
                                        compound.category_compound_id != 7
                                    "
                                    vs-lg="3"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-3 mx-2"
                                  >
                                    <div class="vx-row">
                                      <vs-input
                                        :label="
                                          $t('routines_templates.labels.reps')
                                        "
                                        v-model="workout.repetitions"
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col
                                    v-if="
                                      compound.category_compound_id != 5 &&
                                        compound.category_compound_id != 7
                                    "
                                    vs-lg="3"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-3 mx-2"
                                  >
                                    <div class="vx-row">
                                      <vs-input
                                        :label="
                                          $t('routines_templates.labels.rest')
                                        "
                                        v-model="workout.rest"
                                      />
                                    </div>
                                  </vs-col>


                                  <vs-col
                                    v-if="
                                      compound.category_compound_id != 5 &&
                                        compound.category_compound_id != 7
                                    "
                                    vs-lg="3"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-3 mx-2"
                                  >
                                    <div class="vx-row">
                                      <vs-input
                                        :label="
                                          $t('routines_templates.labels.tempo')
                                        "
                                        placeholder="(1-2-3)"
                                        name="tempo"
                                        class="w-full"
                                        v-model="workout.tempo"
                                      />
                                    </div>
                                  </vs-col>
                                  <vs-col
                                    vs-lg="6"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-1 py-3"
                                  >
                                    <vs-textarea
                                      :label="
                                        $t('routines_templates.labels.note')
                                      "
                                      name="note"
                                      rows="2"
                                      class="w-full"
                                      v-model="workout.note"
                                    />
                                  </vs-col>
                                  <vs-col
                                    vs-lg="6"
                                    vs-sm="12"
                                    vs-xs="12"
                                    class="p-1 py-3"
                                  >
                                    <vs-textarea
                                      :label="
                                        $t('routines_templates.labels.overload')
                                      "
                                      name="note"
                                      rows="2"
                                      class="w-full"
                                      v-model="workout.overload"
                                      v-if="
                                        compound.category_compound_id != 5 &&
                                          compound.category_compound_id != 7
                                      "
                                    />
                                  </vs-col>
                                  <vs-divider></vs-divider>
                                </vs-row>
                              </template>
                            </vs-col>
                          </vs-row>
                          <vs-row class="justify-end">
                            <vs-col vs-lg="8" vs-sm="12" vs-xs="12">
                              <vx-select
                                :model.sync="compound.category_compound_id"
                                label="Tipo de ejercicio"
                                :options="categoriesCompounds"
                                :translate="false"
                                :uuid="false"
                                :placeholder="'Ejecicio'"
                                class="w-full abs"
                              ></vx-select>
                            </vs-col>
                            <vs-col
                              vs-lg="4"
                              vs-sm="12"
                              vs-xs="12"
                              class="pt-4 text-center"
                            >
                              <vs-button
                                class="md:mb-0"
                                v-on:click="
                                  addCompound(
                                    compound.category_compound_id,
                                    'Estiramiento'
                                  )
                                "
                                button="button"
                              >
                                {{ $t('routines_templates.labels.add') }}
                              </vs-button>
                            </vs-col>
                          </vs-row>
                        </vs-card>
                      </vs-tab>
                    </template>
                  </vs-tabs>
                </vs-tab>
              </template>
            </vs-tabs>
          </div>
        </div>
      </div>

      <div class="flex flex-wrap justify-between pr-4">
        <div class="mb-6 ml-5 flex flex-wrap justify-between">
          <vs-button class="mb-2 mx-1" v-if="!form.uuid" button="submit">
            {{ $t('messages.create.title') }}
          </vs-button>
          <vs-button class="mb-2 mx-1" v-else button="submit">
            {{ $t('messages.edit.title') }}
          </vs-button>
          <vs-button class="mb-2 mx-1" v-on:click="replicateWeeks">
            <span>Replicar Semanas </span>
          </vs-button>
        </div>
      </div>
    </form>
  </vx-modal>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'
import Form from 'vform'

export default {
  data() {
    return {
      form: new Form({
        uuid: null,
        name: '',
        description: '',
        category_routine_id: '',
        price: 1
      }),
      PlaceholderRoutime: 'Selecciona una plantilla',
      idRoutine: null,
      routine: {
        uuid: null
      },
      routines: [],
      none: {
        id: 0,
        name: 'Ninguno'
      },
      categories: [],
      categoriesCompounds: [],
      compound: {
        category_compound_id: 6,
        stage: '',
        workouts: []
      },
      workouts: [],
      disableButton: false,
      show: false,
      weeks: [],
      workout: {
        workout_id: null,
        series: 0,
        repetitions: 0,
        rest: 0,
        tempo: null,
        note: ' ',
        timer: 0.0,
        overload: ' ',
        weight: 0,
        preparing_time: 0
      },
      day: 0,
      week: 0,
      alpha: [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z'
      ]
    }
  },
  watch: {
    show(value) {
      if (!value) {
        this.clearForm()
      }
    },
    week(value) {
      if (value !== null) {
        this.day = 0
      }
    },
    routine(value, old) {
      this.selectedRoutine(value)
    }
  },
  methods: {
    async showModal() {
      this.show = true
      await this.getCategories()
      await this.getWorkouts()
      await this.getCompoundsCategories()
      if (!this.form.uuid) {
        this.generateWeeks()
      }
      await this.getRoutines()
    },
    save() {
      if (this.form.uuid) {
        this.edit()
      } else {
        this.create()
      }
    },
    async getRoutines() {
      const params = {
        size: 5000
      }
      const { data } = await axios.get(
        `${process.env.VUE_APP_API_URL}/api/routines`, {
          params
        }
      )
      this.routines = data.data
      if (this.idRoutine !== null) {
        this.routines.forEach((element) => {
          if (element.id === this.idRoutine) {
            this.PlaceholderRoutime = element.name
          }
        })
      }
    },
    
    async selectedRoutine(uuid) {
      if (uuid !== undefined) {
        try {
          this.weeks = []
          const { data } = await axios.get(
            `${process.env.VUE_APP_API_URL}/api/routines/${uuid}`
          )
          _.forEach(
            data.weeks,
            function (week) {
              const days = [
                {
                  number: 1,
                  type_work: null,
                  compounds: []
                },
                {
                  number: 2,
                  type_work: null,
                  compounds: []
                },
                {
                  number: 3,
                  type_work: null,
                  compounds: []
                },
                {
                  number: 4,
                  type_work: null,
                  compounds: []
                },
                {
                  number: 5,
                  type_work: null,
                  compounds: []
                },
                {
                  number: 6,
                  type_work: null,
                  compounds: []
                },
                {
                  number: 7,
                  type_work: null,
                  compounds: []
                }
              ]
              for (let i = 0; i < week.compounds.length; i++) {
                const index = _.findIndex(days, function (d) {
                  // eslint-disable-next-line eqeqeq
                  return d.number == week.compounds[i].day.day
                })
                if (index !== -1) {
                days[index].type_work = week.compounds[i].day.type_work
                  days[index].compounds.push({
                    ...week.compounds[i].day,
                    workouts: Object.values(week.compounds[i].workouts),
                    category_compound_id: week.compounds[i].category.id,
                    category_compound_name: week.compounds[i].category.name
                  })
                }

                for (let j = 0; j < days[index].compounds.length; j++) {
                  for (
                    let k = 0;
                    k < days[index].compounds[j].workouts.length;
                    k++
                  ) {
                    days[index].compounds[j].workouts[k] = {
                      ...days[index].compounds[j].workouts[k],
                      ...days[index].compounds[j].workouts[k].workout
                    }
                    delete days[index].compounds[j].workouts[k].workout
                  }
                }
              }
              this.weeks.push({
                id: week.id,
                number: week.number,
                days
              })
            }.bind(this)
          )
          // eslint-disable-next-line no-unused-vars
          const tempWeeks = this.weeks.map((element, index) => {
            // eslint-disable-next-line no-unused-vars
            element.days.forEach((elem, ind) => {
              // eslint-disable-next-line no-unused-vars
              elem.compounds.forEach((com, comIndx) => {
                com.compound_id = null
              })
            })
            return element
          })
          this.weeks = tempWeeks
          this.idRoutine = data.id
        } catch (error) {
          console.log('Ocurrió un error:', error)
        }
      }
    },
    async create() {
      let message_title = null
      let message_content = null
      let message_type = null
      const vm = this
      try {
        vm.disableButton = true

        vm.$vs.loading()
        this.form.weeks = this.weeks
        // eslint-disable-next-line no-unused-vars
        const { data } = await vm.form.post(
          `${process.env.VUE_APP_API_URL}/api/routines`
        )
        vm.$parent.getRoutines()
        vm.$vs.loading.close()

        message_type = 'success'
        message_content = vm.$t('messages.create.messages.success_description')
        message_title = vm.$t('messages.create.messages.success')
        vm.showMessage(message_type, message_title, message_content)
        vm.show = false
        vm.clearForm()
      } catch (exception) {
        vm.$vs.loading.close()
        console.log('Ocurrió un error:', exception)
      }
      vm.disableButton = false
    },
    async edit() {
      let message_title = null
      let message_content = null
      let message_type = null
      const vm = this
      try {
        vm.disableButton = true
        vm.$vs.loading()
        this.form.weeks = this.weeks
        this.form._method="PATCH"
        const { data } = await vm.form.post(
          `${process.env.VUE_APP_API_URL}/api/routines/${vm.form.uuid}`
        )
        vm.$parent.getRoutines()
        vm.$vs.loading.close()
        vm.form = Object.assign(vm.form, data)
        message_type = 'success'
        message_content = vm.$t('messages.edit.messages.success_description')
        message_title = vm.$t('messages.edit.messages.success')
        vm.showMessage(message_type, message_title, message_content)
        vm.show = false
        vm.clearForm()
      } catch (exception) {
        vm.$vs.loading.close()
        console.log('Ocurrió un error:', exception)
      }
      vm.disableButton = false
    },
    async getRoutine(uuid) {
      try {
        this.weeks = []
        const { data } = await axios.get(
          `${process.env.VUE_APP_API_URL}/api/routines/${uuid}`
        )
        _.forEach(
          data.weeks,
          function (week) {
            const days = [
              {
                number: 1,
                type_work: null,
                compounds: []
              },
              {
                number: 2,
                type_work: null,
                compounds: []
              },
              {
                number: 3,
                type_work: null,
                compounds: []
              },
              {
                number: 4,
                type_work: null,
                compounds: []
              },
              {
                number: 5,
                type_work: null,
                compounds: []
              },
              {
                number: 6,
                type_work: null,
                compounds: []
              },
              {
                number: 7,
                type_work: null,
                compounds: []
              }
            ]
            for (let i = 0; i < week.compounds.length; i++) {
              const index = _.findIndex(days, function (d) {
                // eslint-disable-next-line eqeqeq
                return d.number == week.compounds[i].day.day
              })
              if (index !== -1) {
                days[index].type_work = week.compounds[i].day.type_work
                days[index].compounds.push({
                  ...week.compounds[i].day,
                  ...week.compounds[i].day,
                  workouts: Object.values(week.compounds[i].workouts),
                  category_compound_id: week.compounds[i].category.id,
                  category_compound_name: week.compounds[i].category.name
                })
              }

              for (let j = 0; j < days[index].compounds.length; j++) {
                for (
                  let k = 0;
                  k < days[index].compounds[j].workouts.length;
                  k++
                ) {
                  days[index].compounds[j].workouts[k] = {
                    ...days[index].compounds[j].workouts[k],
                    ...days[index].compounds[j].workouts[k].workout
                  }
                  delete days[index].compounds[j].workouts[k].workout
                }
              }
            }
            this.weeks.push({
              id: week.id,
              number: week.number,
              days
            })
          }.bind(this)
        )
        console.log(data)
        data.weeks = this.weeks

        this.form = _.assign(this.form, data)
        this.form.price = data.product ? data.product.price : 1
      } catch (error) {
        console.log('Ocurrió un error:', error)
      }
    },
    async getCategories() {
      try {
        const { data } = await axios.get(
          `${process.env.VUE_APP_API_URL}/api/routines/categories`
        )
        this.categories = data.data
      } catch (error) {
        console.log('Ocurrió un error:', error)
      }
    },
    async getWorkouts() {
      try {
        const { data } = await axios.get(
          `${process.env.VUE_APP_API_URL}/api/workouts`
        )
        this.workouts = data.data
        // this.workouts.shift();
        // this.workouts.unshift(this.none)
      } catch (error) {
        console.log('Ocurrió un error:', error)
      }
    },
    async getCompoundsCategories() {
      try {
        const { data } = await axios.get(
          `${process.env.VUE_APP_API_URL}/api/compounds/category`
        )

        this.categoriesCompounds = data
        // this.categoriesCompounds.unshift(this.none)
      } catch (error) {
        console.log('Ocurrió un error:', error)
      }
    },
    showMessage(message_type, message_title, message_content) {
      Swal.fire({
        icon: message_type,
        title: message_title,
        text: message_content,
        confirmButtonText: this.$t('ok')
      })
    },
    clearForm() {
      this.form = _.assign(this.form, {
        uuid: null,
        name: '',
        description: '',
        category_routine_id: '',
        _method: null
      })
      this.generateWeeks()
      this.routines = []
      this.routine = _.assign(this.routine, {
        uuid: null
      })
      this.form.clear()
    },
    generateWeeks() {
      this.weeks = []
      for (let i = 0; i < 4; i++) {
        this.weeks.push({
          id: null,
          number: i + 1,
          days: [
            {
              number: 1,
              compounds: [],
              type_work: null
            },
            {
              number: 2,
              compounds: [],
              type_work: null
            },
            {
              number: 3,
              compounds: [],
              type_work: null
            },
            {
              number: 4,
              compounds: [],
              type_work: null
            },
            {
              number: 5,
              compounds: [],
              type_work: null
            },
            {
              number: 6,
              compounds: [],
              type_work: null
            },
            {
              number: 7,
              compounds: [],
              type_work: null
            }
          ]
        })
      }
    },
    addCompound(type, stage) {
      this.compound = {
        category_compound_id: type,
        stage: '',
        workouts: []
      }
      switch (type) {
        case 1: //Biserie
          this.compound.stage = stage
          this.compound.workouts.push({ ...this.workout })
          this.compound.workouts.push({ ...this.workout })
          break
        case 2: //Triserie
          this.compound.stage = stage
          this.compound.workouts.push({ ...this.workout })
          this.compound.workouts.push({ ...this.workout })
          this.compound.workouts.push({ ...this.workout })
          break
        case 3: //Triserie
          this.compound.stage = stage
          this.compound.workouts.push({ ...this.workout })
          this.compound.workouts.push({ ...this.workout })
          this.compound.workouts.push({ ...this.workout })
          this.compound.workouts.push({ ...this.workout })
          break
        case 4: //Piramidal
          this.compound.stage = stage
          this.compound.workouts.push({ ...this.workout })
          break
        case 5: // Hiit
          this.compound.stage = stage
          this.compound.workouts.push({ ...this.workout })
          break
        case 7: //Cardio
          this.compound.stage = stage
          this.compound.workouts.push({ ...this.workout, workout_id: 1 })
          break 
        default:
          this.compound.stage = stage
          this.compound.workouts.push({ ...this.workout })
          break
      }
      this.weeks[this.week].days[this.day].compounds.push({ ...this.compound })
    },
    deleteCompound(index) {
      this.weeks[this.week].days[this.day].compounds.splice(index, 1)
    },
    getNameCompound(id) {
      const cat = this.categoriesCompounds.filter(cat => cat.id == id)
      if (cat.length > 0) {
        return cat[0].name
      }
    },
    replicateWeeks() {
      const tempWeeks = this.weeks.map((element, index) => {
        element.days = _.cloneDeep(this.weeks[0].days)
        return element
      })

      this.weeks = tempWeeks
      this.showMessage(
        'success',
        'Correcto',
        'Se replicó el contenido de la primera semana en el resto de semanas'
      )
    },
    cloneObject(object, key, newKey) {
      const clonedObj = clone(object)
      const targetKey = clonedObj[key]
      delete clonedObj[key]
      clonedObj[newKey] = targetKey
      return clonedObj
    },
    addPiramidal(compound, workout) {
      console.log(compound, workout)
      compound.workouts.push({ ...this.workout, workout_id: (workout.workout_id) ? (workout.workout_id) : 1})
      console.log(JSON.stringify(compound.workouts, null, 2))
    },
    addHiit(compound, workout) {
      compound.workouts.push({ ...this.workout, preparing_time: workout.preparing_time, rest: workout.res, series: workout.series })
    },
    removeHiit(compound) {
      if(compound.workouts.length > 1){
        compound.workouts.pop()
      }
    }
  }
}
</script>

<style lang="scss">
 .add-reps{
   cursor: pointer; position: absolute; bottom: -3px; padding-top: 10px; color: #fe9b00
 }
</style>
